import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AudioManager } from "./components/AudioManager";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AudioManager>
      <App />
    </AudioManager>
  </React.StrictMode>,
);
